export const STEP_ID = {
  BOOK_WITH_US: 'book-with-us',
  OCCASIONS: 'occasions',
  MENUS: 'menus',
  AREAS: 'areas',
  TIMESLOTS: 'timeslots',
  EXTRAS: 'optional-extras',
  YOUR_DETAILS: 'your-details',
  DEPOSIT: 'deposit',
  CONFIRMATION: 'confirmation',
  ENQUIRY: 'enquiry',
  ENQUIRY_CONFIRMATION: 'enquiry-confirmation',
};

export const VERIFICATION_RESULT_TYPES = {
  NO_NETWORK: 'no-network',
  NO_AVAILABLE_OCCASIONS: 'no-available-occasions',
  NO_BOOKABLE_OCCASIONS: 'no-bookable-occasions',
  NO_AVAILABLE_AREAS: 'no-available-areas',
  NO_AVAILABLE_MENUS: 'no-available-menus',
  VERIFICATION_FAILED: 'verificationFailed',
  CAPACITY_RULES_FAILED: 'capacityRules',
  FULLY_BOOKED: 'fullyBooked',
  OCCASION_FULLY_BOOKED: 'occasionFullyBooked',
  NO_AVAILABLE_TIMESLOTS: 'no-available-timeslots',
};

export const DIRECTION = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

export const JOURNEY_TYPE = {
  CORE: 'core',
  SPORTS: 'sports',
  EVENT_LISTING: 'event listing',
  MULTI_DAY_EVENT: 'multi-day event',
};

export const AVAILABILITY_TYPES = {
  FULL: 'Full',
  MODERATE: 'Moderate',
  LIMITED: 'Limited',
  NONE: 'None',
};

export const ERROR_CATEGORIES = {
  CUSTOMER_FACING_MESSAGE: 'Customer Facing Message',
  VALIDATION_ERROR: 'Validation Error',
  TECHNICAL_ERROR: 'Technical Error',
};

export const STEP_TO_STORE_PROPERTY = {
  [STEP_ID.EXTRAS]: 'extras',
};

export const CANCEL_REASON = {
  PAYMENT_TIME_UP: 'Payment time is up.',
  CANCEL_HOLD: 'Cancel hold',
};

export const USER_DATA_LOCAL_STORAGE_KEY = 'USER_DATA';

export const DEFAULT_TURN_TIME_MINUTES = 60;

export const MILESTONE_STATUS = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  UPCOMING: 'upcoming',
};

export const MILESTONE_STEPS = {
  0: [STEP_ID.BOOK_WITH_US, STEP_ID.OCCASIONS],
  1: [STEP_ID.MENUS, STEP_ID.AREAS, STEP_ID.TIMESLOTS, STEP_ID.EXTRAS],
  2: [
    STEP_ID.YOUR_DETAILS,
    STEP_ID.DEPOSIT,
    STEP_ID.CONFIRMATION,
    STEP_ID.ENQUIRY,
    STEP_ID.ENQUIRY_CONFIRMATION,
  ],
};

export const MILESTONE_HIDDEN_STEPS = [
  STEP_ID.CONFIRMATION,
  STEP_ID.ENQUIRY,
  STEP_ID.ENQUIRY_CONFIRMATION,
];

export const UNAVAILABILITY_REASONS = {
  FullyBooked: 'Area Fully Booked',
  NoTimeslots: 'No Available Timeslots',
  NoAvailability: 'No Availability',
  NotEnoughCapacityLeft: 'Not Enough Capacity',
  NoSuitableTime: "Can't find a suitable time",
};
